import { useSearchParams } from 'react-router-dom';

export function useParamBackUrl(fallback: string) {
  const [search] = useSearchParams();
  return search.get('backURL') ?? fallback;
}
